import {useParams} from "react-router";

const useChatParams = () => {
  const {campaignId, influencerUserId, companyId} = useParams<{
    campaignId: string;
    influencerUserId: string;
    companyId: string;
  }>();

  return {
    campaignId: Number(campaignId),
    influencerUserId: Number(influencerUserId),
    companyId: Number(companyId),
  };
};

export default useChatParams;
